import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Table } from 'primeng/table';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { GrupoService } from 'src/app/admihair/service/grupo.service';

@Component({
  selector: 'app-dashboard-rfarias',
  templateUrl: './dashboard-rfarias.component.html',
  styleUrls: ['./dashboard-rfarias.component.scss']
})
export class DashBoardRfariasComponent implements OnInit {

  constructor() { }

  
  loading: boolean = false;

  grupos: Grupo[] = [];

  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {

 
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}
